const PACKAGE_GRADIENTS: Record<string, [string, string]> = {
  'platinum+': ['#DCDEED', '#D8DDFB'],
  platinum: ['#E2E3EA', '#F0EDFF'],
  gold: ['#DECFA7', '#EDE6D2'],
  silver: ['#D6D6D6', '#EDEDED'],
  basic: ['#E7E7E7', '#F6F7FA'],
  mini: ['#E7E7E7', '#F6F7FA'],
};

export function getPackageGradient(packageName: string) {
  const colors = PACKAGE_GRADIENTS[packageName.trim().toLowerCase()];
  const [from, to] = colors ?? PACKAGE_GRADIENTS.basic;

  return `linear-gradient(315deg, ${from} 0%, ${to} 100%)`;
}
